// @ts-nocheck
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { useMergeStyles } from "@insite/content-library/additionalStyles";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Hidden from "@insite/mobius/Hidden";
import ShoppingBag from "@insite/mobius/Icons/ShoppingBag";
import ShoppingCart from "@insite/mobius/Icons/ShoppingCart";
import Truck from "@insite/mobius/Icons/Truck";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
// import React, { FC, useEffect } from "react"; // Starter Custom Code
import { connect, ResolveThunks } from "react-redux";
import { css, withTheme } from "styled-components";

/* Starter Custom Code - Start */
import { Dictionary } from "@insite/client-framework/Common/Types";
import Popover, { PopoverPresentationProps, PositionStyle } from "@insite/mobius/Popover/Popover";
import HeaderLink, { HeaderLinkStyles } from "@store/Components/Toolkit/HeaderLink";
import CarFill, { CarFillOffset } from "@store/Components/Toolkit/Icons/Car/CarFill";
import Drawer, { DrawerPresentationProps } from "@store/MobiusOverrides/Drawer/Drawer";
import MiniCart, { MiniCartPresentationProps } from "@store/Components/Toolkit/MiniCart";
import ShoppingBagFill, { ShoppingBagFillOffset } from "@store/Components/Toolkit/Icons/ShoppingBag/ShoppingBagFill";
import ShoppingCartFill, {
    ShoppingCartFillOffset,
} from "@store/Components/Toolkit/Icons/ShoppingCart/ShoppingCartFill";
import { countBubbleStyles } from "@store/Themes/common/mixins/countBubble";
import { headerHideForDesktopStyles } from "@store/Themes/common/mixins/header";
import breakpoint from "@store/Framework/Common/Utilities/breakpoint";
import mergeProps from "@store/Framework/Common/Utilities/mergeProps";
import { pxToRem, pxToRemArray } from "@store/Framework/Common/Utilities/unitHelper";
import { IconMap } from "@toolkit/Framework/Types/Icon";
import React, { FC, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { boxStyles } from "@store/Themes/common/mixins/box";
import getColor from "@insite/mobius/utilities/getColor";
import useIsBreakpoint from "@store/Framework/Common/Hooks/useIsBreakpoint";
/* Starter Custom Code - End */

const enum fields {
    visibilityState = "visibilityState",
    icon = "icon",
    // Starter Custom Code
    enableMiniCart = "enableMiniCart",
    disableMiniCartOnMobile = "disableMiniCartOnMobile",
    displayOfTheMiniCart = "displayOfTheMiniCart",
    displayMiniCartCheckoutButtons = "displayMiniCartCheckoutButtons",
    miniCartMaxVisibleItems = "miniCartMaxVisibleItems",
}

const mapStateToProps = (state: ApplicationState) => ({
    shouldLoadCart: !getCurrentCartState(state).value && !getCurrentCartState(state).isLoading,
    totalCountDisplay: getCurrentCartState(state).value?.totalCountDisplay,
    cartUrl: getPageLinkByPageType(state, "CartPage")?.url,
    // Starter Custom Code
    cart: getCurrentCartState(state).value,
});

const mapDispatchToProps = {
    loadCurrentCart,
};

export interface CartLinkStyles {
    routerLink?: LinkPresentationProps;
    desktopCountText?: TypographyPresentationProps;
    mobileCountText?: TypographyPresentationProps;
    compactCountText?: TypographyPresentationProps;
    // Starter Custom Code
    headerLink?: HeaderLinkStyles;
    popover?: PopoverPresentationProps;
    drawer?: DrawerPresentationProps;
    miniCart?: MiniCartPresentationProps;
}

export const cartLinkStyles: CartLinkStyles = {
    mobileCountText: {
        css: css`
            ${countBubbleStyles(pxToRemArray([2, 2]))};
            ${breakpoint("md")} {
                top: 0;
                right: 0;
            }
        `,
    },
    popover: {
        wrapperProps: {
            css: css`
                ${breakpoint("sm", "down")} {
                    position: static;
                }
            `,
        },
        contentBodyProps: {
            as: "div",
            css: css`
                ${boxStyles(null)}
                overflow: initial;
                width: 100%;
                max-height: none;
                padding: ${pxToRem(0, 10)};
                color: ${getColor("text")};
                white-space: nowrap;

                ${breakpoint("sm", "down")} {
                    box-shadow:
                        0 0 0.0625rem 0 rgba(48, 49, 51, 0.05),
                        0 -0.25rem 0.5rem 0 rgba(48, 49, 51, 0.1),
                        0 0 0.0625rem 0 rgba(48, 49, 51, 0.05),
                        0 0.25rem 0.5rem 0 rgba(48, 49, 51, 0.1);
                }

                ${breakpoint("md")} {
                    width: auto;
                }
            `,
        },
    },
    drawer: {
        mergeCss: true,
        position: "right",
        cssOverrides: {
            drawerBody: css`
                width: 100%;

                ${breakpoint("md")} {
                    width: auto;
                }
            `,
            drawerContent: css`
                padding: ${pxToRem(0, 20)};
            `,
        },
    },
};

/* Starter Custom Code - Start */
const iconMap: Dictionary<IconMap | undefined> = {
    cart: {
        src: ShoppingCartFill,
        offset: ShoppingCartFillOffset,
    },
    truck: {
        src: CarFill,
        offset: CarFillOffset,
    },
    bag: {
        src: ShoppingBagFill,
        offset: ShoppingBagFillOffset,
    },
    none: undefined,
};
/* Starter Custom Code - End */

interface OwnProps extends WidgetProps {
    fields: {
        [fields.visibilityState]: "both" | "label" | "icon";
        [fields.icon]: keyof typeof iconMap;
        // Starter Custom Code
        [fields.enableMiniCart]: boolean;
        [fields.displayOfTheMiniCart]: string;
        [fields.disableMiniCartOnMobile]: boolean;
        [fields.displayMiniCartCheckoutButtons]: boolean;
        [fields.miniCartMaxVisibleItems]: number;
    };
    isCompactHeaderCart?: boolean;
    theme: BaseTheme;
}

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

/** Reloading the cart makes `totalCountDisplay` temporarily unavailable, so retain the previous value for better UX. */
let retainedTotalCountToDisplay = 0; // Starter Custom Code

const CartLink: FC<Props> = ({
    shouldLoadCart,
    cartUrl,
    totalCountDisplay,
    fields: {
        visibilityState,
        icon: selectedIcon,
        // Starter Custom Code
        enableMiniCart,
        disableMiniCartOnMobile,
        displayOfTheMiniCart,
        displayMiniCartCheckoutButtons,
        miniCartMaxVisibleItems,
    },
    loadCurrentCart,
    isCompactHeaderCart,
    theme,
    // Starter Custom Code
    cart,
}) => {
    /* Starter Custom Code - Start */
    const [isMiniCartDrawerOpen, setIsMiniCartDrawerOpen] = useState(false);
    const popoverRef = useRef<HTMLUListElement>(null);
    const popoverBodyRef = useRef<HTMLUListElement>(null);
    const isMobile = useIsBreakpoint("sm", "down");

    const positionFunction = useCallback(() => {
        const result: PositionStyle = { position: "absolute" };
        result.right = 0;
        return result;
    }, []);
    /* Starter Custom Code - End */

    useEffect(() => {
        if (shouldLoadCart) {
            loadCurrentCart({
                shouldLoadFullCart: false,
                replaceCart: false,
                getCartLines: enableMiniCart, // Starter Custom Code
            });
        }
    }, [shouldLoadCart, enableMiniCart, loadCurrentCart]);

    /* Starter Custom Code - Start */
    useEffect(() => {
        if (enableMiniCart && !cart?.cartLines && (cart?.lineCount ?? 0) > 0) {
            loadCurrentCart({ shouldLoadFullCart: false, replaceCart: false, getCartLines: true });
        }
    }, [enableMiniCart, cart?.cartLines, cart?.lineCount]);
    /* Starter Custom Code - End */

    const baseStyles = useMergeStyles("cartLink", cartLinkStyles); // Starter Custom Code

    // Starter Removed - showIcon
    // Starter Removed - showLabel

    if (typeof totalCountDisplay !== "undefined") {
        retainedTotalCountToDisplay = totalCountDisplay;
    }

    const icon = iconMap[selectedIcon || "none"]; // Starter Custom Code

    // Starter Removed - routerLink

    /* Starter Custom Code - Start */
    const showIconOnly = visibilityState === "icon" || isCompactHeaderCart; // Starter Custom Code
    const itemsText = retainedTotalCountToDisplay === 1 ? translate("Item") : translate("Items");

    const styles = useMemo(() => {
        if (showIconOnly) {
            return baseStyles;
        }

        return mergeProps<CartLinkStyles>(baseStyles, {
            mobileCountText: {
                css: headerHideForDesktopStyles(),
            },
        });
    }, [baseStyles, visibilityState]);
    /* Starter Custom Code - End */

    // Starter Removed - isCompactHeaderCart

    /* Starter Custom Code - Start */
    const renderHeaderLink = (props?: Partial<React.ComponentProps<typeof HeaderLink>>) => (
        <HeaderLink
            iconSrc={icon?.src}
            iconOffset={icon?.offset}
            showIconOnly={showIconOnly}
            label={translate("Cart")}
            text={`${retainedTotalCountToDisplay} ${itemsText}`}
            extendedStyles={styles.headerLink}
            data-test-selector="cartLink"
            {...props}
        >
            {retainedTotalCountToDisplay ? (
                <Typography {...styles.mobileCountText} aria-hidden="true">
                    {retainedTotalCountToDisplay}
                </Typography>
            ) : null}
        </HeaderLink>
    );

    if (!enableMiniCart || (disableMiniCartOnMobile && isMobile)) {
        return renderHeaderLink({ href: cartUrl });
    }

    const closeMiniCartPopover = () => {
        (popoverRef.current as any) && (popoverRef.current! as any).closePopover();
    };

    const closeMiniCartDrawer = () => {
        setIsMiniCartDrawerOpen(false);
    };

    return (
        <>
            {displayOfTheMiniCart === "popover" ? (
                <Popover
                    {...styles.popover}
                    contentBodyProps={{
                        ref: popoverBodyRef,
                        ...styles.popover?.contentBodyProps,
                    }}
                    positionFunction={positionFunction}
                    ref={popoverRef}
                    insideRefs={[popoverBodyRef]}
                    popoverTrigger={renderHeaderLink({
                        "aria-haspopup": "dialog",
                    })}
                >
                    <MiniCart
                        displayCheckoutButtons={displayMiniCartCheckoutButtons}
                        maxVisibleItems={miniCartMaxVisibleItems}
                        onClose={closeMiniCartPopover}
                        extendedStyles={styles.miniCart}
                    />
                </Popover>
            ) : null}
            {displayOfTheMiniCart === "drawer" ? (
                <>
                    {renderHeaderLink({
                        "aria-expanded": isMiniCartDrawerOpen,
                        "aria-haspopup": "dialog",
                        onClick: event => {
                            event.preventDefault();
                            setIsMiniCartDrawerOpen(true);
                        },
                    })}
                    <Drawer
                        {...styles.drawer}
                        isOpen={isMiniCartDrawerOpen}
                        closeButtonAccessibleText={translate("Close cart")}
                        handleClose={closeMiniCartDrawer}
                        contentLabel={translate("Cart drawer")}
                    >
                        <MiniCart
                            displayCheckoutButtons={displayMiniCartCheckoutButtons}
                            onClose={closeMiniCartDrawer}
                            extendedStyles={styles.miniCart}
                        />
                    </Drawer>
                </>
            ) : null}
        </>
    );
    /* Starter Custom Code - End */
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withTheme(CartLink)),
    definition: {
        displayName: "Cart",
        icon: "cart-shopping",
        fieldDefinitions: [
            {
                name: fields.visibilityState,
                displayName: "Settings",
                editorTemplate: "RadioButtonsField",
                options: [
                    {
                        displayName: "Show Icon and Label", // Starter Custom Code
                        value: "both",
                    },
                    // Starter Removed - Show Label Only
                    {
                        displayName: "Show Icon Only",
                        value: "icon",
                    },
                ],
                defaultValue: "both",
                fieldType: "General",
                sortOrder: 1,
            },
            {
                name: fields.icon,
                displayName: "Shopping Cart Icon",
                editorTemplate: "DropDownField",
                options: [
                    // Starter Removed - None
                    {
                        displayName: "Bag",
                        value: "bag",
                    },
                    {
                        displayName: "Cart",
                        value: "cart",
                    },
                    {
                        displayName: "Truck",
                        value: "truck",
                    },
                ],
                defaultValue: "cart",
                fieldType: "General",
                sortOrder: 2,
                isRequired: true, // Starter Custom Code
            },
            // Starter Custom Code
            {
                name: fields.enableMiniCart,
                displayName: "Enable Mini Cart",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
                variant: "toggle",
            },
            {
                name: fields.displayOfTheMiniCart,
                displayName: "Display of the Mini Cart",
                editorTemplate: "RadioButtonsField",
                options: [
                    {
                        displayName: "Popover",
                        value: "popover",
                    },
                    {
                        displayName: "Drawer",
                        value: "drawer",
                    },
                ],
                defaultValue: "popover",
                fieldType: "General",
                tooltip: "Choose if the mini cart will be displayed in a popover or in a drawer.",
                tooltipPosition: "left",
                isVisible: item => item.fields.enableMiniCart,
            },
            {
                name: fields.miniCartMaxVisibleItems,
                displayName: "Max Visible Items",
                editorTemplate: "IntegerField",
                min: 3,
                max: 10,
                defaultValue: 5,
                fieldType: "General",
                tooltip:
                    "Set the maximum number of cart lines to show in the mini cart before collapsing the rest into a scrollable area.",
                tooltipPosition: "left",
                isVisible: item => item.fields.enableMiniCart && item.fields.displayOfTheMiniCart === "popover",
            },
            {
                name: fields.displayMiniCartCheckoutButtons,
                displayName: "Display Mini Cart Checkout Buttons",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
                tooltip:
                    "Choose whether to show the checkout buttons (Checkout, Submit for Quote, etc.) in the mini cart.",
                tooltipPosition: "left",
                isVisible: item => item.fields.enableMiniCart,
            },
            {
                name: fields.disableMiniCartOnMobile,
                displayName: "Disable Mini Cart On Mobile",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
                isVisible: item => item.fields.enableMiniCart,
            },
        ],
        group: "Common",
    },
};

export default widgetModule;
